export const DEFAULT_PAYMENT_SOURCE = 'publishObjectNew';
